import { RouteConfig } from "vue-router";

const registrationRoutes: RouteConfig[] = [
  {
    path: "",
    name: "registerInfo",
    meta: {
      title: "meta.register",
      authorize: [],
    },
    component: () => import("@/components/registration/PatientRegistrationInfo.vue"),
  },
  {
    path: "form",
    name: "register",
    meta: {
      title: "meta.register",
      authorize: [],
    },
    component: () => import("@/components/registration/PatientRegistrationForm.vue"),
  },
  {
    path: "success",
    name: "registerSuccess",
    meta: {
      title: "meta.register",
      authorize: [],
    },
    component: () => import("@/components/registration/PatientRegistrationSuccess.vue"),
  },
  {
    path: "error",
    name: "registerError",
    meta: {
      title: "meta.register",
      authorize: [],
    },
    component: () => import("@/components/registration/PatientRegistrationError.vue"),
  },
];

export default registrationRoutes;
